import React, { Component } from 'react'
import includes from 'lodash/includes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as taskTypesDuck from '../../../../store/shared/taskTypesDuck'
import * as adminTasksAssignmentDuck from '../adminTasksAssignmentDuck'
import AssignTaskOption from './AssignTaskOption'

/**
 * @class AssignTaskManager
 * @description Handles displaying and assigning Tasks
 */
class AssignTaskManager extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    assignedTasksByType: PropTypes.object.isRequired,
    assignedTaskTypes: PropTypes.array.isRequired,
    performRetrieveTasks: PropTypes.func.isRequired,
    taskTypes: PropTypes.array.isRequired,
    toggleTasksCreateModal: PropTypes.func.isRequired,
  }

  /**
   * @method componentWillMount
   */
  componentWillMount() {
    this.props.performRetrieveTasks()
  }

  render() {
    const { taskTypes, assignedTasksByType, assignedTaskTypes, toggleTasksCreateModal } = this.props

    return (
      <div className="table-responsive">
        <table className="table table-striped table-sm">
          <thead>
            <tr>
              <th>Task Type</th>
              <th id="tasksCompleted">Students Completed</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
          {taskTypes.map(item => (
            item.active &&
            <AssignTaskOption
              key={item.type}
              data={item}
              onClick={toggleTasksCreateModal}
              tasks={assignedTasksByType[item.type]}
              assigned={includes(assignedTaskTypes, item.type)}
            />
          ))}
          </tbody>
        </table>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  taskTypes: taskTypesDuck.getTaskTypes(state),
  assignedTasksByType: adminTasksAssignmentDuck.getAssignedTasksByType(state),
  assignedTaskTypes: adminTasksAssignmentDuck.getAssignedTaskTypes(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performRetrieveTasks: adminTasksAssignmentDuck.performRetrieveTasks,
      toggleTasksCreateModal: adminTasksAssignmentDuck.toggleModal,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(AssignTaskManager)



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/components/AssignTaskManager.js